/* ------------------------------------------------------------------
   StudioLayout.js — parent layout for the AI Studio section.
   Sub-navigation lives in the dashboard sidebar (collapsible "AI Studio"
   group), so this is a thin wrapper that renders the active sub-page.
   Room for more AI content-creation tools later.
------------------------------------------------------------------ */
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function StudioLayout() {
  return <Outlet />;
}
